var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0947266 10.002C0.0958901 14.9214 3.67313 19.1101 8.53173 19.881V12.892H5.99473V10.002H8.53473V7.80204C8.42118 6.75958 8.77725 5.72064 9.50637 4.96698C10.2355 4.21332 11.2621 3.82306 12.3077 3.90204C13.0583 3.91417 13.8069 3.98101 14.5477 4.10205V6.56104H13.2837C12.8486 6.50405 12.4111 6.64777 12.0945 6.95171C11.7779 7.25566 11.6165 7.68693 11.6557 8.12404V10.002H14.4267L13.9837 12.893H11.6557V19.881C16.9102 19.0506 20.5948 14.2518 20.0402 8.96112C19.4857 3.67041 14.886 -0.260027 9.57355 0.0172227C4.26109 0.294472 0.095571 4.68235 0.0947266 10.002Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8e88bcc8a8128fa1b114482e96c080b0.svg";
export { ForwardRef as ReactComponent };